import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClick"];
import React, { Fragment } from 'react';
import classNames from 'classnames/bind';
import { SearchLink } from "../../SearchLink";
import { Markup } from "../../../../../internal/Markup";
import { TextBase } from "../../../../../internal/TextBase";
import { Favorites } from '../../Favorites';
import { MobileAccordionItem } from '../../MobileAccordionItem';
import styles from '../MobileMenuCanary.css';
var cx = classNames.bind(styles);
export var B2CMenu = function B2CMenu(_ref) {
  var accordionExpandedItems = _ref.accordionExpandedItems,
      navigation = _ref.navigation,
      navigationFavorites = _ref.navigationFavorites,
      setSubmenu = _ref.setSubmenu,
      toggleAccordionItem = _ref.toggleAccordionItem;
  var accordionItems = (navigation || []).map(function (_ref2, i) {
    var favorites = _ref2.favorites,
        items = _ref2.items,
        subtitle = _ref2.subtitle,
        title = _ref2.title,
        _ref2$titleProps = _ref2.titleProps;
    _ref2$titleProps = _ref2$titleProps === void 0 ? {} : _ref2$titleProps;

    var titlePropsOnClick = _ref2$titleProps.onClick,
        titleProps = _objectWithoutProperties(_ref2$titleProps, _excluded);

    return {
      children:
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: i
      }, favorites && /*#__PURE__*/React.createElement(Favorites, {
        items: favorites
      }), items && items.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: cx('items')
      }, items.map(function (item, index) {
        if (item.href) {
          return /*#__PURE__*/React.createElement("div", {
            className: cx('item')
          }, /*#__PURE__*/React.createElement(SearchLink, {
            title: item.title,
            href: item.href,
            target: item.target
          }));
        }

        return /*#__PURE__*/React.createElement("button", _extends({
          key: item.title,
          className: cx('item'),
          onClick: function onClick(event) {
            if (setSubmenu) {
              setSubmenu([i, index]);
            }

            if (titlePropsOnClick) {
              titlePropsOnClick(event);
            }
          }
        }, titleProps, {
          type: "button"
        }), /*#__PURE__*/React.createElement(TextBase, {
          size: "l",
          as: "span",
          color: "N100"
        }, /*#__PURE__*/React.createElement(Markup, {
          text: item.title
        })), item.points && /*#__PURE__*/React.createElement("span", {
          className: cx('nested-points-count')
        }, /*#__PURE__*/React.createElement(TextBase, {
          size: "s",
          color: "N300"
        }, item.points.length)));
      }))),
      subtitle: subtitle,
      title: title
    };
  });

  if (Object.keys(navigationFavorites).length) {
    accordionItems.unshift({
      children: /*#__PURE__*/React.createElement(Favorites, {
        items: navigationFavorites.items
      }),
      title: navigationFavorites.title,
      subtitle: navigationFavorites.subtitle
    });
  }

  return /*#__PURE__*/React.createElement(Fragment, null, accordionItems.map(function (_ref3, i) {
    var children = _ref3.children,
        subtitle = _ref3.subtitle,
        title = _ref3.title;
    return /*#__PURE__*/React.createElement(MobileAccordionItem, {
      key: title,
      onOpenChange: function onOpenChange() {
        return toggleAccordionItem(i);
      },
      open: accordionExpandedItems.includes(i),
      title: title,
      subtitle: subtitle
    }, children);
  }));
};